import React from 'react';
import PropTypes from 'prop-types';

import EmptyStates from '../empty-states';
import withTranslate from '../../hoc/with-translate';
import { PAGE_TYPE } from '../../state/ff-page/constants';
import StyledButton from '../styled-button';
import { FOLLOWING_FOLLOWERS } from '../../constants/app-components';
import {
  EMPTY_STATE_CONSTANTS,
} from '../../constants/empty-state';

import styles from './ff-desktop.scss';

const ownProfileKeyPrefixByPageType = {
  [PAGE_TYPE.FOLLOWERS]: 'ff.no-own-followers',
  [PAGE_TYPE.FOLLOWING]: 'ff.no-own-following',
};

const otherProfileKeyPrefixByPageType = {
  [PAGE_TYPE.FOLLOWERS]: 'ff.no-followers',
  [PAGE_TYPE.FOLLOWING]: 'ff.no-following',
};

const NoContent = ({ t, isOwnProfile, pageType, onViewMembersClick, showViewMembersButton }) => {
  const titleKey = isOwnProfile
    ? `${ownProfileKeyPrefixByPageType[pageType]}.title`
    : `${otherProfileKeyPrefixByPageType[pageType]}.title`;

  const contentKey = isOwnProfile
    ? `${ownProfileKeyPrefixByPageType[pageType]}.content`
    : `${otherProfileKeyPrefixByPageType[pageType]}.content`;

  const isOwnAndFollowing = isOwnProfile && pageType === PAGE_TYPE.FOLLOWING;

  const ViewMembersButton = () => (
    <StyledButton
      className={styles.viewMembersButton}
      onClick={() => onViewMembersClick()}
      dataHook="ffViewMembersButton"
    >
      {t('ff.no-own-following.button-title')}
    </StyledButton>
  );

  return (
    <EmptyStates
      title={t(titleKey)}
      content={t(contentKey)}
      appComponent={FOLLOWING_FOLLOWERS}
      noBoxClass
      titleFontClassName={EMPTY_STATE_CONSTANTS.title}
      descriptionFontClassName={EMPTY_STATE_CONSTANTS.description}
    >
      {isOwnAndFollowing && showViewMembersButton && <ViewMembersButton />}
    </EmptyStates>
  );
};

NoContent.propTypes = {
  t: PropTypes.func,
  isOwnProfile: PropTypes.bool.isRequired,
  pageType: PropTypes.string.isRequired,
  onViewMembersClick: PropTypes.func,
  showViewMembersButton: PropTypes.bool.isRequired,
};

export default withTranslate(NoContent);
